import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the SearchPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'searchveda',
})
export class SearchVedaPipe implements PipeTransform {
    /**
     * Takes a value and makes it lowercase.
     */
  
    transform(items: any, veda: any): any {
      if (veda) {
          veda = veda.toLowerCase();
          return items.filter(item => {
              return Object.keys(item).some(
                  k => {
                      if (item[k] != null && item[k] != undefined && typeof item[k] == 'string')
                           return item[k].toLowerCase().startsWith(veda);
                        //return item[k].includes(nakshatra);
                  }
              );
          });
      }
      return items;
    }
  
  }


// WEBPACK FOOTER //
// ./src/pipes/search/searchveda.ts